import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { WebshopPublicDataDto } from '../store/webshop/webshop.models';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class WebshopService {
  private http = inject(HttpClient);
  private apiUrl = environment.apiUrl;
  private webshopId = environment.webshopId;
  private language = environment.language;

  getPublicData(): Observable<WebshopPublicDataDto> {
    return this.http.get<WebshopPublicDataDto>(`${this.apiUrl}/public/webshops/${this.webshopId}?lang=${this.language}`);
  }
}
